<template>
  <v-container fluid pa-0 ma-0>
    <v-layout :id="'printable-ach-authorization-' + transaction.tracking_id" hidden-screen-only>
      <v-container fill-height pa-0 ma-0>
        <v-layout row wrap>
<div class="invoice-box" style="margin: auto;font-size: 16px;line-height: 24px;font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;color: #555;">
<table cellpadding="0" cellspacing="0" style="width: 100%;line-height: inherit;text-align: left;">

<tr class="information">
<td colspan="2" style="padding: 5px;vertical-align: top;">
<table style="width: 100%;line-height: inherit;text-align: left;">
<tr>
<td style="padding: 5px;vertical-align: top;padding-bottom: 10px;width: 100%;display: block;text-align: center;">

<div v-if="transaction.account_logo" style="float: left;">
<img :src="imageUrl + '/' + transaction.account_logo" style="max-width:242px; max-height:100px;" />
</div>

<b><h3>Authorization for Direct Payment Via ACH</h3>
(ACH DEBITS/ELECTRONIC DEBITS) </b><br>
<p style="clear: both;">
I authorize ({{ accountSelected.name }}) hereinafter named COMPANY to initiate an ACH/electronic debit to my account indicated below. I agree that future payments with COMPANY for purchase of ongoing products or services may be automatically debited from the account indicated below and future changes in my order for product or services may change the amount debited. I agree that ACH transactions I authorize comply with all applicable law. I understand that this authorization will remain in full force and effect until I notify COMPANY in writing that I wish to revoke this authorization. I understand that COMPANY requires at least 15 days prior notice in order to cancel this authorization.
</p>
<br><b>Please verify your banking information:</b>
</td>
<td style="padding: 5px;vertical-align: top;text-align: center;padding-bottom: 10px;width: 100%;display: block;"></td>
</tr>
</table>
</td>
</tr>
<tr class="heading">
<td style="padding: 5px;vertical-align: top;background: #eee;border-bottom: 1px solid #ddd;font-weight: bold;">
Account Number:
</td>
<td style="padding: 5px;vertical-align: top;text-align: right;background: #eee;border-bottom: 1px solid #ddd;font-weight: bold;">
**********{{ transaction.last_four }}
</td>
</tr>

<tr class="heading">
<td style="padding: 5px;vertical-align: top;background: #eee;border-bottom: 1px solid #ddd;font-weight: bold;">
Routing Number:
</td>

<td style="padding: 5px;vertical-align: top;text-align: right;background: #eee;border-bottom: 1px solid #ddd;font-weight: bold;">
{{ transaction.ach_routing_number }}
</td>
</tr>

<tr class="heading">
<td style="padding: 5px;vertical-align: top;background: #eee;border-bottom: 1px solid #ddd;font-weight: bold;">
Authorized Payment Amount:
</td>

<td style="padding: 5px;vertical-align: top;text-align: right;background: #eee;border-bottom: 1px solid #ddd;font-weight: bold;">
${{ ((transaction.total_amount - transaction.fee_amount - transaction.tax_amount) / 100).toFixed(2) }}
</td>
</tr>

<tr class="item">
<td style="padding: 5px;vertical-align: top;border-bottom: 1px solid #eee;">
Date Authorized:
</td>
<td style="padding: 5px;vertical-align: top;text-align: right;border-bottom: 1px solid #eee;">
{{ date(Date.now()) }}
</td>
</tr>

<tr class="item2">
<td style="padding: 5px;vertical-align: top;padding-top: 40px;padding-bottom: 20px;">
Name: ________________________________
</td>
<td style="padding: 5px;vertical-align: top;text-align: right;padding-top: 40px;padding-bottom: 20px;"></td>
</tr>

<tr class="item3">
<td style="padding: 5px;vertical-align: top;padding-top: 20px;padding-bottom: 20px;">
Date: _________________________________
</td>
<td style="padding: 5px;vertical-align: top;text-align: right;padding-top: 20px;padding-bottom: 20px;"></td>
</tr>

<tr class="item3">
<td style="padding: 5px;vertical-align: top;padding-top: 20px;padding-bottom: 20px;">
Signature: _____________________________
</td>
<td style="padding: 5px;vertical-align: top;text-align: right;padding-top: 20px;padding-bottom: 20px;"></td>
</tr>

</table>

</div>
        </v-layout>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import { Printd } from 'printd'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      enabled: false,
      imageUrl: process.env.VUE_APP_IMAGE_URL || 'https://paynetworx-dev-images.s3.us-west-2.amazonaws.com'
    }
  },

  props: {
    transaction: Object
  },

  mounted () {
    if (process.env.NODE_ENV === 'production') {
      this.imageUrl = process.env.VUE_APP_IMAGE_URL || 'https://paynetworx-images.s3.us-west-2.amazonaws.com'
    }
  },

  methods: {
    print () {
      // handle page title change which is used for 'save as pdf'
      const printCallback = ({ launchPrint }) => {
        document.title = 'ACH Authorization'
        launchPrint()
      }
      const printd = new Printd()
      printd.print(document.getElementById('printable-ach-authorization-' + this.transaction.tracking_id), [], [], printCallback)
    },
    email () {},
    save () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/AchAuthPrint.vue